import { setMobileCSSCustomProperties } from '../helpers/util'
import { initGallery } from '../modules/Gallery'
import { downloadIrSetup } from '../modules/DownloadInfoRequest'
import { initQuoteForm } from '../modules/Products'
import { requireCountryCode } from '../helpers/util'

document.addEventListener('DOMContentLoaded', () => {
  const referrerField = document.querySelector('.referrer')
  if (referrerField) referrerField.value = document.referrer // Set HTTP referer

  setMobileCSSCustomProperties()
  initGallery()
  downloadIrSetup()
  requireCountryCode(initQuoteForm)
});
